import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {PagingResolverService} from '@abstract/paging-resolver.service';
import {WorkingObjectTechnicalDevicePagesService} from './working-object-technical-device-pages.service';

/**
 * Получение данных по ТУ
 */
@Injectable()
export class FilteredTechnicalDevicesResolver extends PagingResolverService {
    constructor(
        service: WorkingObjectTechnicalDevicePagesService,
        router: Router,
    ) {
        super(service, router);
    }

    resolve(snapshot: ActivatedRouteSnapshot) {
        const service = this.resolverService as WorkingObjectTechnicalDevicePagesService;


        /**
         * Если Id объекта не поменялась (мы вернулись в тот же объект, из которого уходили крайний раз),
         * то сохраняем параметры фильтрации, а если это новый объект, то сбрасываем.
         * Это позволит сохранить контекст работы с объектом, пока мы не перейдем в новый
         */
        const id = +snapshot.parent.params.id;

        if (id !== service.workingObjectId) {
            service.resetParams();
        }

        service.workingObjectId = id;

        return super.resolve(snapshot);
    }
}
